import { IGetPaymentMethodOptionsProps } from './types';

export const getPaymentMethodOptionProps = ({
  defaultPaymentMethodId,
  setDefaultPaymentMethodId,
  accountIdentifier,
}: IGetPaymentMethodOptionsProps) => {
  return {
    selected: defaultPaymentMethodId === accountIdentifier,
    onPress: () => {
      if (defaultPaymentMethodId === accountIdentifier) {
        return;
      }

      setDefaultPaymentMethodId(accountIdentifier);
    },
    revaultRequired: false,
  };
};
